import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {toast} from 'react-toastify'
import {ToastMessage} from '~/react/components'
import {useRails} from '~/react/contexts/rails'
import {CrossIcon, CheckIcon} from '~/react/icons'
import {acceptTermsAndConditions} from '../../api'

export const useTermsAcceptance = (onClose, refresh) => {
  const {t} = useTranslation('points')
  const {authenticityToken, currentSupplier} = useRails()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleAcceptTerms = async () => {
    setIsSubmitting(true)
    try {
      await acceptTermsAndConditions({
        supplierId: currentSupplier?.id,
        authenticityToken,
      })

      toast.dark(
        <ToastMessage>
          <CheckIcon mr={1} color="mld.success.700" />
          {t('termsAndConditionsModal.success.message')}
        </ToastMessage>,
      )

      onClose()

      refresh()
    } catch {
      toast.dark(
        <ToastMessage>
          <CrossIcon mr={1} color="mld.alert.700" />
          {t('termsAndConditionsModal.error.message')}
        </ToastMessage>,
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    handleAcceptTerms,
    isSubmitting,
  }
}
